"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const Lock_1 = __importDefault(require("../../assets/icons/Lock"));
const Words_1 = __importDefault(require("../../assets/icons/Words"));
const scale_1 = require("../../utils/scale");
const ModalRange_1 = __importDefault(require("../modal/ModalRange"));
const CustomText_1 = __importDefault(require("../text/CustomText"));
const PublicRangeView = (props) => {
    const { publicRange, disabled = true } = props;
    const [visible, setVisible] = (0, react_1.useState)(false);
    const [range, setRange] = (0, react_1.useState)(publicRange);
    const isActive = range == 0;
    return (react_1.default.createElement(react_native_1.View, { style: { alignSelf: 'flex-start', marginTop: (0, scale_1.scale)(12) } },
        react_1.default.createElement(react_native_1.TouchableOpacity, { disabled: disabled, style: [
                styles.box,
                isActive && {
                    borderColor: '#287BCF'
                }
            ], onPress: () => setVisible(true) },
            isActive ?
                react_1.default.createElement(Words_1.default, null)
                :
                    react_1.default.createElement(Lock_1.default, null),
            react_1.default.createElement(CustomText_1.default, { weight: "600", style: [styles.label, isActive && { color: '#287BCF' }] }, isActive ? '全員に公開' : 'フォロワー限定')),
        react_1.default.createElement(ModalRange_1.default, { visible: visible, onClose: () => setVisible(false), value: range, onSelect: (index) => { setRange(index), setVisible(false); } })));
};
const styles = react_native_1.StyleSheet.create({
    box: {
        paddingVertical: (0, scale_1.scale)(4),
        paddingHorizontal: (0, scale_1.scale)(8),
        borderWidth: (0, scale_1.scale)(1),
        borderColor: "#575B72",
        borderRadius: 999,
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "row",
        backgroundColor: '#FEFEFE'
    },
    label: {
        fontSize: (0, scale_1.moderateScale)(10),
        lineHeight: (0, scale_1.moderateScale)(17),
        color: "#575B72",
        marginLeft: (0, scale_1.scale)(4),
    }
});
exports.default = PublicRangeView;
